import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SectorsService } from 'projects/services/src/app/API/sectors.service';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { GeographiesService } from 'projects/services/src/app/API/geographies.service';
import { TotBatchService } from 'projects/services/src/app/API/tot-batch.service'
import { disclaimerCertidicationAccessorAndTrainer } from 'projects/shared/src/app/shared/constants/constants'
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import { UserService } from 'projects/services/src/app/API/user.service';
declare const swal: any;
declare const toastr: any;
import * as moment from 'moment';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';


@Component({
	selector: 'app-applicant-add-certificate',
	templateUrl: './applicant-add-certificate.component.html',
	styleUrls: ['./applicant-add-certificate.component.css']
})
export class ApplicantAddCertificateComponent implements OnInit, AfterViewInit {

	countries: any = [];
	loginType: any;
	applicantId: any;
	cerificationUploadForm: FormGroup;
	// doc variables
	doc: any;
	temp: any = {};
	docUrl: any;
	docLink: any;
	showDownlod = false;
	showUpload = false;
	buttonText: any = 'Download Document'
	// DropDown Data
	totalSectors: any[] = [];
	totalSubSectors: any[] = [];
	totalStates: any[] = [];
	totalDistricts: any[] = [];
	totalJobRoles: any[] = [];
	totalTrainingModels: any[] = [];
	applicantData = {
		userName: '',
		jobrole: '',
		type: '',
		certReqId: ''
	}
	// Disclaimer
	disclaimer: any;
	localFileName = {
		disabilityProof: '',
		identityProof: '',
		photo: '',
		educationProof: '',
		workExperienceProof: '',
		trainingExperienceProof: '',
		resume: '',
		pan: ''
	};
	// Edit Variables
	jobRoleId: any;
	tabType: any;
	certificateDetails: any;
	jobRoleDetails: any;
	trainingModel: any;
	// bootstrap date picker
	dateId1 = 'traAndAssCertificateIssueDate';
	dateId2 = 'startDateSSCPayment';
	todayDate: any = new Date;
	// Temp variable
	type: any; // if edit or creae type
	tempData: any;
	userType: any;
	availableCertificate: any = [];
	pageNo = 1;
	perPage = 10;
	count: number;
	certReqId: any;
	showField = false;
	currentUser: any;

	batchMode = [
		{
			id: 1,
			value: 'Online'
		},
		{
			id: 2,
			value: 'Offline'
		}
	]

	constructor(
		private fb: FormBuilder,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private sectorService: SectorsService,
		private geographiesService: GeographiesService,
		private totToaBatchService: TotBatchService,
		private _script: ScriptLoaderService,
		private userService: UserService,
		private currentUserService: CurrentUserService
	) {
	}

	ngOnInit() {
		console.log(this.loginType);
		this.type = 'create'
		// Check if Edit scenario
		if (this.activatedRoute.snapshot.queryParams.jobRoleId) {
			console.log(this.activatedRoute.snapshot.queryParams);
			this.type = 'edit'
			this.applicantId = this.activatedRoute.snapshot.queryParams.applicantId;
			this.jobRoleId = this.activatedRoute.snapshot.queryParams.jobRoleId;
			this.tabType = this.activatedRoute.snapshot.queryParams.tabType;
			this.certReqId = Number(this.activatedRoute.snapshot.queryParams.reqId);
			this.loginType = this.activatedRoute.snapshot.queryParams.loginType;
			this.applicantData.userName = this.activatedRoute.snapshot.queryParams.applicantId ?
				this.activatedRoute.snapshot.queryParams.applicantId : '';
			this.applicantData.jobrole = this.activatedRoute.snapshot.queryParams.jobRoleId;
			this.applicantData.type = this.activatedRoute.snapshot.queryParams.batchType;
			this.userType = this.activatedRoute.snapshot.queryParams.userType;
			this.applicantData.certReqId = this.activatedRoute.snapshot.queryParams.reqId;
			this.initalizeeform();
			// Edit Logic;
		} else {
			this.showUpload = true;
		}

		// Build Form
		this.buildCerificationUploadForm();
		this.getCountries();

		// Static Disclaimer
		this.disclaimer = disclaimerCertidicationAccessorAndTrainer.disclaimer;

		// Form Change Events
		this.formControlValueChanged()
		// Get Dropdown Data
		this.getSectors();
		this.getStates();
		this.getTrainingMdels();
		this.getCurrentUser();
	}

	ngAfterViewInit() {
		this._script.addScriptTagToElementDOM(
			'../../../assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js'
		);
	}

	// Build Form
	buildCerificationUploadForm() {
		this.cerificationUploadForm = this.fb.group({
			sector: ['', [Validators.required]],
			// subSector: ['', [Validators.required]],
			jobRole: ['', [Validators.required]],
			trainingModel: ['', [Validators.required]],
			country: ['', Validators.required],
			batchMode: ['', Validators.required],
			state: ['', [Validators.required]],
			district: ['', [Validators.required]],
			certificateId: ['', [Validators.maxLength(30), Validators.pattern('^[A-Za-z0-9][A-Za-z0-9-/,&()%$#@!`~\|?>< \s\']*$')]],
			certificateIssueDate: [null],
			validTillDate: [null],
			domainPercentage: ['', [Validators.pattern('^(([0-9]{1,2})|([0-9]{1,2}[.][0-9]{1,2})|([1][0][0]))$')]],
			platformPercentage: ['', [Validators.pattern('^(([0-9]{1,2})|([0-9]{1,2}[.][0-9]{1,2})|([1][0][0]))$')]],
			// tslint:disable-next-line:max-line-length
			provisionalCertificate: [null, [ValidationService.fileValidator, ValidationService.fileTypeValidator('png', 'jpg', 'pdf', 'jpeg'), ValidationService.fileSizeValidator(5)]],
			remarkToSsc: [null, [Validators.maxLength(500), Validators.pattern('^[A-Za-z0-9][A-Za-z0-9-/,.&()%$#@!`~\\n|?>< \s\']*$')]],
			declaration: [false, [Validators.required]]
		})
	}

	getCurrentUser() {
		this.currentUserService.getCurrentUser().subscribe(res => {
			console.log(res);
			this.applicantId = res.userName;
			this.currentUser = res
		})
	}

	initalizeeform() {
		this.getParticularCertificateDetails().then(res => {
			if (res) {
				this.disableBaseFeilds();
			}
		})
	}

	patchCountryValue() {
		if (this.currentUser.originationCategory === 'domestic') {
			const defaultValue = {
				code: 91,
				country: 'India',
				countryId: 'IN'
			}
			this.showField = true;
			this.countries.push(defaultValue);
			this.cerificationUploadForm.get('country').setValue(defaultValue);
			this.cerificationUploadForm.get('country').disable();
		} else if (this.currentUser.originationCategory === 'international') {
			this.showField = false
			if (this.certificateDetails && this.certificateDetails.address) {
				this.cerificationUploadForm.get('country').setValue(this.certificateDetails.address.country)
				this.cerificationUploadForm.get('country').disable();
			}
			this.cerificationUploadForm.get('state').setValidators([]);
			this.cerificationUploadForm.get('state').updateValueAndValidity();
			this.cerificationUploadForm.get('district').setValidators([]);
			this.cerificationUploadForm.get('district').updateValueAndValidity();
		}
	}

	// get Certificate details
	getParticularCertificateDetails() {
		return new Promise((resolve, reject) => {
			this.userService.getParticularJobRoleCertificateDetails(this.tabType, this.applicantData).subscribe(res => {
				this.certificateDetails = res.data[0];
				if (this.tabType === 'Rejected') {
					this.totalJobRoles.push({
						jobRoleId: this.certificateDetails.jobRoleId,
						version: this.certificateDetails.version,
						jobRoleDesc: this.certificateDetails.jobRoleDesc,
						jobName: this.certificateDetails.jobName,
						nsqfLevel: this.certificateDetails.nsqfLevel,
						jobroleName: this.certificateDetails.jobName + ' (' + this.certificateDetails.jobRoleId + ') ' + '- ' + 'v' + this.certificateDetails.version,
					});
				}
				this.patchCountryValue();
				console.log(this.certificateDetails);
				// Enable disable form With respect to status
				if (this.certificateDetails.certificateDetails.certificateStatus === 'PENDING' ||
					this.certificateDetails.certificateDetails.certificateStatus === 'APPROVED') {
					if (this.activatedRoute.snapshot.queryParams.loginType !== 'SSC') {
						this.cerificationUploadForm.disable();
						this.showUpload = false;
					} else {
						console.log(this.cerificationUploadForm.controls['trainingModel']);
						this.trainingModel = this.cerificationUploadForm.controls['trainingModel'];
						this.cerificationUploadForm.controls['state'].disable();
						this.cerificationUploadForm.controls['district'].disable();
						this.cerificationUploadForm.controls['trainingModel'].disable();
						this.cerificationUploadForm.controls['remarkToSsc'].disable();
					}
					// When Submitted or Approved
					this.showDownlod = true;
					this.showUpload = true;
					this.docLink = this.certificateDetails.certificateDetails &&
						this.certificateDetails.certificateDetails.supportingDocumentURLDetails &&
						this.certificateDetails.certificateDetails.supportingDocumentURLDetails.location ?
						this.certificateDetails.certificateDetails.supportingDocumentURLDetails.location : '';
				}
				// During Reject
				if (this.certificateDetails.certificateDetails.certificateStatus === 'REJECTED') {
					this.showDownlod = true;
					this.showUpload = true;
					this.docLink = this.certificateDetails.certificateDetails &&
						this.certificateDetails.certificateDetails.supportingDocumentURLDetails &&
						this.certificateDetails.certificateDetails.supportingDocumentURLDetails.location ?
						this.certificateDetails.certificateDetails.supportingDocumentURLDetails.location : '';
				}
				// Mandate Feilds Patch
				this.cerificationUploadForm.
					get('sector').patchValue(this.certificateDetails.sector);
				// this.cerificationUploadForm.
				// 	get('subSector').patchValue(this.certificateDetails.subSectors);
				this.jobRoleDetails = {
					jobName: this.certificateDetails.jobName,
					jobRoleDesc: this.certificateDetails.jobRoleDesc,
					jobRoleId: this.certificateDetails.jobRoleId,
					nsqfLevel: this.certificateDetails.nsqfLevel,
					version: this.certificateDetails.version
				}
				this.cerificationUploadForm.
					get('jobRole').patchValue(this.jobRoleDetails);
				this.cerificationUploadForm.
					get('trainingModel').patchValue(this.certificateDetails.batchType);
				this.cerificationUploadForm.
					get('batchMode').patchValue(this.certificateDetails.batchMode);
				this.cerificationUploadForm.
					get('state').patchValue(
						this.certificateDetails.address && this.certificateDetails.address.state ? this.certificateDetails.address.state : {});
				this.cerificationUploadForm.
					get('district').patchValue(
						this.certificateDetails.address && this.certificateDetails.address.district ? this.certificateDetails.address.district : {});
				this.cerificationUploadForm.
					get('provisionalCertificate').patchValue(this.certificateDetails.certificateDetails &&
						this.certificateDetails.certificateDetails.supportingDocumentURLDetails &&
						this.certificateDetails.certificateDetails.supportingDocumentURLDetails.location ?
						this.certificateDetails.certificateDetails.supportingDocumentURLDetails.location : '');
				// optional Feils Patch
				if (this.certificateDetails.platformPercentage) {
					this.cerificationUploadForm.get('platformPercentage').patchValue(this.certificateDetails.platformPercentage);
				}
				if (this.certificateDetails.assmtCrt.percentage) {
					this.cerificationUploadForm.get('domainPercentage').patchValue(this.certificateDetails.assmtCrt.percentage);
				}
				if (this.certificateDetails.certificateDetails.certificateID) {
					this.cerificationUploadForm.get('certificateId').patchValue(this.certificateDetails.certificateDetails.certificateID);
				}
				if (this.certificateDetails.remarks.toSSC.comment) {
					this.cerificationUploadForm.get('remarkToSsc').patchValue(this.certificateDetails.remarks.toSSC.comment);
				}
				if (this.certificateDetails.certificateDetails.certificateIssueDate) {
					const patchIsDate = moment(this.certificateDetails.certificateDetails.certificateIssueDate).format('DD/MM/YYYY');
					this.cerificationUploadForm.get('certificateIssueDate').patchValue(patchIsDate);
				}
				if (this.certificateDetails.certificateDetails.certificateValidTillDate) {
					const patchValDate1 = moment(this.certificateDetails.certificateDetails.certificateValidTillDate).format('DD/MM/YYYY');
					this.cerificationUploadForm.get('validTillDate').patchValue(patchValDate1);
				}
				console.log(this.cerificationUploadForm.value);
				this.cerificationUploadForm.get('declaration').patchValue(true);
				return resolve(true);
			}, err => {
				return resolve(true);
			})
		})
	}

	// Disable Basic Feilds
	disableBaseFeilds() {
		this.cerificationUploadForm.controls['sector'].disable();
		this.cerificationUploadForm.get('sector').updateValueAndValidity();
		this.cerificationUploadForm.controls['jobRole'].disable();
		this.cerificationUploadForm.controls['jobRole'].updateValueAndValidity();
		this.cerificationUploadForm.controls['trainingModel'].disable();
		this.cerificationUploadForm.controls['trainingModel'].updateValueAndValidity();
	}

	// Listen to form control value chages

	formControlValueChanged() {
		let sectorId;
		let subSectorId;
		// Sector change
		this.cerificationUploadForm.get('sector').valueChanges.subscribe(
			(sector: any) => {
				if (sector && sector.id) {
					sectorId = sector.id;
					if (this.tabType !== 'Rejected') {
						this.getJobRoles(sector.id);
					}
				}
			});
		this.cerificationUploadForm.get('jobRole').valueChanges.subscribe((jobRole: any) => {
		})
		// get districts on state change
		this.cerificationUploadForm.get('state').valueChanges.subscribe((state: any) => {
			if (state && state.id) {
				this.cerificationUploadForm.get('district').setValue('');
				this.getDistricts(state.id);
			}
		})
	}

	getJobRoles(sector, subSector?) {
		sector = sector ? sector : this.cerificationUploadForm.value.sector.id;
		// subSector = subSector ? subSector : this.cerificationUploadForm.value.subSector.subSectorID;
		console.log(this.cerificationUploadForm.value);
		this.sectorService.getJobRoles(sector, subSector).subscribe(res => {
			if (res.data) {
				if (res.data.length > 0) {
					this.totalJobRoles = res.data.map(r => {
						return {
							jobRoleId: r.qpCode ? r.qpCode : '',
							version: r.version ? r.version : '',
							jobRoleDesc: r.jobRoleDesc ? r.jobRoleDesc : '',
							jobName: r.jobRole ? r.jobRole : '',
							nsqfLevel: r.nsqfLevel ? r.nsqfLevel : '',
							jobroleName: r.qpCode && r.jobRole ? r.jobRole + ' (' + r.qpCode + ') ' + '- ' + 'v' + r.version : '',
						}
					});
				} else {
					this.totalJobRoles = [];
					toastr.error('No Job Role Found');
				}
			}
			console.log(this.totalJobRoles);
		})
	}

	getTrainingMdels() {
		const user = this.currentUserService.decodeToken();
		const currentUserrole = user.role;
		console.log(currentUserrole);
		this.totToaBatchService.getAllTrainingModels().subscribe(res => {
			if (currentUserrole === "Trainer") {
				for (let i = 0; i < res.length; i++) {
					if (res[i].type === "TOTNEW") {
						this.totalTrainingModels.push(res[i])
					} else if (res[i].type === "TOTEXISTING") {
						this.totalTrainingModels.push(res[i])
					} else if (res[i].type === "TOMT") {
						this.totalTrainingModels.push(res[i])
					}
				}
			}
			if (currentUserrole === "Assessor") {
				for (let i = 0; i < res.length; i++) {
					if (res[i].type === "TOANEW") {
						this.totalTrainingModels.push(res[i])
					} else if (res[i].type === "TOMA") {
						this.totalTrainingModels.push(res[i])
					} else if (res[i].type === "TOAEXISTING") {
						this.totalTrainingModels.push(res[i])
					}
				}
			}
			console.log(res);
		})
	}

	getCountries() {
		this.geographiesService.getCountries().subscribe(country => {
			console.log(country);
			if (country) {
				this.countries = country;
				this.patchCountryValue();
			}
		})
	}

	getStates() {
		this.geographiesService.getStates().subscribe(res => {
			this.totalStates = res.states.map(r => {
				return {
					id: r.code,
					name: r.name
				}
			});
		})
	}

	// get dropdowns data
	getSectors() {
		this.sectorService.getSectors().subscribe(res => {
			this.totalSectors = res.map(r => {
				return {
					name: r.sector,
					id: r.sectorID
				}
			});
		})
	}


	getDistricts(id?) {
		const stateId = id;
		this.geographiesService.getDistricts(stateId).subscribe(res => {
			this.totalDistricts = res.districts.map(r => {
				return {
					id: r.code,
					name: r.name
				}
			});
			console.log(res);
		})
	}

	showCountry(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.countryId === formControlValue.countryCode) || (item.countryId === formControlValue.countryId) || (item.country === formControlValue.name));
		} else {
			return false;
		}
	}

	// Compare Functions
	compareSectors(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.id === formControlValue.id));
		} else {
			return false;
		}
	}

	compareBatchMode(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.id === formControlValue.id));
		} else {
			return false;
		}
	}


	compareSubSector(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.subSectorID === formControlValue.subSectorID));
		} else {
			return false;
		}
	}

	compareJobRoleName(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.jobRoleId === formControlValue.jobRoleId));
		} else {
			return false;
		}
	}

	compareTrainingModel(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.name === formControlValue.name));
		} else {
			return false;
		}
	}

	compareStateAndDistrict(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.id === formControlValue.id));
		} else {
			return false;
		}
	}

	// Date Event Functions
	assignednDate(event) {
		if (event.target.value) {
			const [day, month, year] = (event.target.value).split('/');
			const formattedDate = moment(new Date(year, month - 1, day)).format('DD/MM/YYYY');
			console.log('from date', formattedDate);
			this.cerificationUploadForm.get('certificateIssueDate').setValue(formattedDate);
		}
	}

	validTill(event) {
		console.log(event);
		if (event.target.value) {
			const [day, month, year] = (event.target.value).split('/');
			const formattedDate1 = moment(new Date(year, month - 1, day)).format('DD/MM/YYYY');
			console.log('To date', formattedDate1);
			this.cerificationUploadForm.get('validTillDate').setValue(formattedDate1);
		}
	}

	mapRequestData(request) {
		console.log(this.applicantId, request);
		const formData = request;
		let cIssueDate;
		let cValidTillDate;
		if (formData.certificateIssueDate) {
			const temp1 = Helpers.toDateFromCalendar(formData.certificateIssueDate);
			cIssueDate = temp1.toISOString();
		}
		if (formData.validTillDate) {
			const temp2 = Helpers.toDateFromCalendar(formData.validTillDate);
			cValidTillDate = temp2.toISOString();
		}
		console.log(formData);
		const data = {
			'batchType': formData.trainingModel ? formData.trainingModel : this.trainingModel,
			'batchMode': formData.batchMode ? formData.batchMode : '',
			'applicantID': this.applicantId ? this.applicantId : this.applicantData.userName,
			'jobRoleId': formData.jobRole.jobRoleId ? formData.jobRole.jobRoleId : '',
			'version': formData.jobRole.version ? formData.jobRole.version : '',
			'jobRoleDesc': formData.jobRole.jobRoleDesc ? formData.jobRole.jobRoleDesc : '',
			'jobName': formData.jobRole.jobName ? formData.jobRole.jobName : '',
			'nsqfLevel': formData.jobRole.nsqfLevel ? formData.jobRole.nsqfLevel : '',
			'platformPercentage': formData.platformPercentage ? formData.platformPercentage : 0,
			'sector': formData.sector ? formData.sector : '',
			'certReqId': this.certReqId,
			// 'subSectors': formData.subSector ? formData.subSector : '',
			'address': {
				'country': {
					'name': formData.country.country ? formData.country.country : formData.country.name ? formData.country.name : '',
					'id': formData.country.code ? formData.country.code : 0,
					'countryCode': formData.country.countryId ? formData.country.countryId : formData.country.countryCode ? formData.country.countryCode : ''
				},
				'state': {
					'name': formData.state.name ? formData.state.name : '',
					'id': formData.state.id ? formData.state.id : 0
				},
				'district': {
					'name': formData.district.name ? formData.district.name : '',
					'id': formData.district.id ? formData.district.id : 0
				}
			},
			'remarks': {
				'toSSC': {
					'comment': formData.remarkToSsc ? formData.remarkToSsc : '',
					'commentedOn': this.todayDate ? this.todayDate : ''
				}
			},
			'assmtCrt': {
				'percentage': formData.domainPercentage ? formData.domainPercentage : 0,
			},
			// "assmtCrt": null,
			'certificateDetails': {
				'certificateID': formData.certificateId ? formData.certificateId : '',
				'certificateIssueDate': cIssueDate ? cIssueDate : null,
				'certificateValidTillDate': cValidTillDate ? cValidTillDate : null,
				'certificateType': this.userType,
				'supportingDocumentURLDetails': {
					'location': formData.provisionalCertificate ? formData.provisionalCertificate : ''
				},
			}
		}
		const sscData = {
			'batchType': formData.trainingModel ? formData.trainingModel : this.trainingModel,
			'applicantID': this.applicantId ? this.applicantId : this.applicantData.userName,
			'qpCode': formData.jobRole.jobRoleId,
			'status': 'PENDING',
			'certReqId': this.certReqId,
			'comment': formData.remarkToSsc !== null ? formData.remarkToSsc : '',
			'documentURL': formData.provisionalCertificate,
			'domainPercentage': {
				'percentage': formData.domainPercentage
			},
			'platformPercentage': formData.platformPercentage,
			'certificateID': formData.certificateId,
			'certificateIssueDate': cIssueDate ? cIssueDate : null,
			'certificateValidTillDate': cValidTillDate ? cValidTillDate : null,
			'certificateType': this.userType,
		}
		if (this.loginType === 'SSC') {
			this.showUpload = true;
			return sscData;
		} else {
			return data;
		}
	}

	onVerifyCertificate() {
		const formData = this.cerificationUploadForm.getRawValue();
		formData.platformPercentage = Number(formData.platformPercentage);
		formData.domainPercentage = Number(formData.domainPercentage);
		const data = {
			qpCode: this.cerificationUploadForm.value.jobRole && this.cerificationUploadForm.value.jobRole.jobRoleId ? this.cerificationUploadForm.value.jobRole.jobRoleId : formData.jobRole.jobRoleId,
			batchType: this.cerificationUploadForm.value.trainingModel && this.cerificationUploadForm.value.trainingModel.name ? this.cerificationUploadForm.value.trainingModel.name : formData.jobRole.name,
			userName: this.applicantId
		}
		this.userService.getCertificateAvailability(this.pageNo, this.perPage, 'Approved', data).subscribe(res => {
			console.log(res);
			if (res.count > 0) {
				Helpers.openModal('acceptreject');
				this.availableCertificate = res.data;
				this.count = res.count;
			} else {
				Helpers.closeModal('acceptreject');
				this.onSubmit();
			}
		});
	}

	getCategory(data) {
		if (data && data.assmtCrt) {

			if (data.assmtCrt.grade === 'A') {
				return 'A';
			}
			if (data.assmtCrt.grade === 'B') {
				return 'B';
			}
			if (data.assmtCrt.grade === 'C') {
				return 'Provisional';
			}

		}
	}


	// On Submit
	onSubmit() {
		const formData = this.cerificationUploadForm.getRawValue();
		formData.platformPercentage = Number(formData.platformPercentage);
		formData.domainPercentage = Number(formData.domainPercentage);
		console.log(formData);
		console.log(this.cerificationUploadForm.value);
		const requestData = this.mapRequestData(formData);
		console.log(requestData);
		this.userService.addCertificate(requestData, this.type).subscribe(res => {
			if (this.type === 'edit') {
				swal('Certificate Details Updated Successfully', '', 'success');
			} else {
				swal('Certificate Submitted Successfully to SSC', `Please wait for the concerned Sector Skill Council to approve certification`, 'success');
			}
			this.routeToList();
		}, err => {
			console.log(err);
		})
	}

	routeToList() {
		if (this.loginType === 'SSC') {
			this.router.navigate(['../certificate'], {
				relativeTo: this.activatedRoute
			})
		} else {
			this.router.navigate(['../applicant-certification-list'], {
				relativeTo: this.activatedRoute
			})
		}
	}

	assignPageNo(pageNo) {
		this.pageNo = pageNo;
		this.onVerifyCertificate();
	}
	assignPerPage(perPage) {
		this.perPage = perPage;
		this.onVerifyCertificate();
	}

	setDefaults() {
		this.pageNo = 1;
		this.perPage = 10;
	}

}
